import type { TypographyOptions } from "@mui/material/styles/createTypography";
import {
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_MEDIUM,
  FONT_WEIGHT_REGULAR,
} from "@/constants/layout";

export const pxToRem = (value: number): string => `${value / 16}rem`;

interface ResponsiveSizes {
  sm: number;
  md: number;
  lg: number;
}

const responsiveFontSizes = ({ sm, md, lg }: ResponsiveSizes) => ({
  "@media (min-width:900px)": { fontSize: pxToRem(lg) },
  "@media (max-width:900px)": { fontSize: pxToRem(md) },
  "@media (max-width:600px)": { fontSize: pxToRem(sm) },
});

const typography: TypographyOptions & Record<string, unknown> = {
  fontFamily: "Poppins, Roboto, Corben, serif, sans-serif",
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_MEDIUM,
  FONT_WEIGHT_BOLD,
  h1: {
    fontWeight: FONT_WEIGHT_BOLD,
    lineHeight: pxToRem(78),
    fontSize: pxToRem(60),
    ...responsiveFontSizes({ sm: 50, md: 55, lg: 60 }),
  },
  h2: {
    fontWeight: FONT_WEIGHT_BOLD,
    lineHeight: pxToRem(65),
    fontSize: pxToRem(50),
    ...responsiveFontSizes({ sm: 40, md: 45, lg: 50 }),
  },
  h3: {
    fontWeight: FONT_WEIGHT_BOLD,
    lineHeight: pxToRem(52),
    fontSize: pxToRem(40),
    ...responsiveFontSizes({ sm: 32, md: 36, lg: 40 }),
  },
  h4: {
    fontWeight: FONT_WEIGHT_BOLD,
    lineHeight: pxToRem(41.6),
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 24, md: 28, lg: 32 }),
  },
  h5: {
    fontWeight: FONT_WEIGHT_MEDIUM,
    lineHeight: pxToRem(24 * 1.3),
    fontSize: pxToRem(24),
  },
  h6: {
    fontWeight: FONT_WEIGHT_MEDIUM,
    lineHeight: pxToRem(24.7),
    fontSize: pxToRem(19),
  },
  subtitle1: {
    fontWeight: FONT_WEIGHT_MEDIUM,
    lineHeight: pxToRem(20.8),
    fontSize: pxToRem(16),
  },
  subtitle2: {
    fontWeight: FONT_WEIGHT_MEDIUM,
    lineHeight: pxToRem(18.2),
    fontSize: pxToRem(14),
  },
  body1: { lineHeight: pxToRem(20.8), fontSize: pxToRem(16) },
  body2: { lineHeight: pxToRem(18.2), fontSize: pxToRem(14) },
  caption: { lineHeight: pxToRem(12 * 1.3), fontSize: pxToRem(12) },
  overline: {
    fontWeight: FONT_WEIGHT_BOLD,
    lineHeight: pxToRem(12 * 1.3),
    fontSize: pxToRem(12),
    letterSpacing: 1.1,
  },
  button: {
    fontWeight: FONT_WEIGHT_BOLD,
    lineHeight: pxToRem(18.2),
    fontSize: pxToRem(14),
  },
};

export default typography;
